import {LightBulbIcon, PlusIcon, XIcon} from '@primer/octicons-react'
import {ActionList} from '@primer/react'
import {forwardRef, type RefObject, useState} from 'react'

import {suggestedPersonalInstructions} from '../utils/custom-instructions'

export interface TemplateProps {
  onSelect: (key: string, value: string | undefined) => void
}
export type Ref = HTMLUListElement | null

export const PersonalInstructionsTemplates = forwardRef<Ref, TemplateProps>(
  function PersonalInstructionsTemplatesWithRef(props, ref) {
    const {onSelect} = props
    const [showTemplates, setShowTemplates] = useState<boolean>(false)
    const toggleShowTemplates = () => setShowTemplates(!showTemplates)

    return (
      <ActionList
        ref={ref as RefObject<HTMLUListElement>}
        className={'d-flex ml-2 flex-wrap gap-2 position-absolute bgColor-default rounded-2'}
        style={{bottom: '1px', width: '94%'}}
      >
        {showTemplates &&
          Object.entries(suggestedPersonalInstructions)?.map(([key, value]) => (
            <ActionList.Item
              aria-label={`${value.tooltip}`}
              className={`mx-0 border fgColor-muted d-inline-block width-auto`}
              key={key}
              onSelect={() => onSelect(key, value.body)}
            >
              <PlusIcon className="mr-1" />
              {key}
            </ActionList.Item>
          ))}
        <ActionList.Item
          aria-label={showTemplates ? 'Hide templates' : 'Show templates'}
          data-testid="toggle-templates"
          className={`mr-1 fgColor-muted d-inline-block ml-auto width-auto flex-justify-end`}
          style={{border: '1px solid transparent'}} // To prevent height change as light bulb icon is smaller than X icon
          onSelect={toggleShowTemplates}
        >
          {showTemplates ? <XIcon /> : <LightBulbIcon />}
        </ActionList.Item>
      </ActionList>
    )
  },
)

try{ PersonalInstructionsTemplates.displayName ||= 'PersonalInstructionsTemplates' } catch {}
try{ PersonalInstructionsTemplatesWithRef.displayName ||= 'PersonalInstructionsTemplatesWithRef' } catch {}